import { useMemo } from 'react';
import { Divider, Paper, Box, Card, CardContent, CardMedia, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';

import TopicMark from "@imgs/icon-camp-return.png";


const kClr_m1 = "#FA9A29";
const kClr_m3 = "#FFF3E6";

export default function PolicyCard() {
  const aryPolicy: { key: string, policy: string }[] = useMemo(() => {
    return [
      {
        key: "policy1",
        policy: '1. お客様と共に繁栄する会社になること。'
      },
      {
        key: "policy2",
        policy: '2. ユーザーから真に信頼されるサービスを提供する会社になること。'
      },
      {
        key: "policy3",
        policy: '3. 常に新しい技術を取り入れ蓄積し、成長している会社になること。'
      },
    ]
  }, [])
  return (
    <Box component="section" id="point" sx={{ mt: 2, pb: 0 }}>
      <Box component="div" className="container">
        <Paper sx={{
          px: { xs: 1, sm: 3 }, py: { xs: 1, sm: 3 },
          bgcolor: kClr_m3,
          border: 3, borderColor: kClr_m1, borderRadius: 4
        }}
        >
          <Card >
            <CardMedia
              sx={{ height: 20 }}
              title="green iguana"
            />
            <CardContent>
              <Grid xs={12} sm={12} sx={{ mt: 1, ml: { xs: 1, sm: 2 }, fontSize: '18px', fontWeight: 600 }}>
                <Box component="img" src={TopicMark}
                  sx={{ width: '40px', height: '40px', mb: '-10px', mr: '5px', border: 0, borderRadius: '2px' }}
                />
                会社方針
              </Grid>
              <Divider sx={{ mb: 3 }} />

              <Grid container spacing={2} sx={{ m: 2 }}>
                {
                  aryPolicy.map((pair: { key: string, policy: string }, index) => (
                    <>
                      <Grid key={index}>
                        <Typography variant="subtitle1">
                          {pair.policy}
                        </Typography>
                      </Grid>
                    </>
                  )
                  )
                }
              </Grid>
            </CardContent>
          </Card>
        </Paper>
      </Box>
    </Box>
  );
}
